import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import {
  getLeaderboardUsersList,
  getLeaderboardUsersPoints,
} from "store/actions"

const Leaderboard = props => {
  useEffect(() => {
    props.getLeaderboardUsersPoints({ event_id: props.selectedEvent.id })
  }, [])

  useEffect(() => {
    if (props.leaderboardUsersPoints.length > 0) {
      props.getLeaderboardUsersList({
        user_ids: props.leaderboardUsersPoints.map(x => x.user_id),
      })
    }
  }, [props.leaderboardUsersPoints])

  return (
    <Card>
      <CardBody>
        <Row>
          <Col>
            <h5>
              This is a list with all the users that have earned points in the
              event.
            </h5>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="table-responsive">
              <table className="table table-nowrap align-middle mb-0">
                <tbody>
                  {props.leaderboardUsersList &&
                    props.leaderboardUsersPoints.map((item, i) => {
                      const user = props.leaderboardUsersList[`${item.user_id}`]
                      return (
                        <tr key={i}>
                          <td className="col-1">
                            <div className="avatar-group">
                              <div className="avatar-group-item">
                                <img
                                  src={
                                    user?.profile_pic
                                      ? user?.profile_pic?.file?.url
                                      : "https://admin.dev.markedprivate.com/app/images/profile_placeholder.jpg"
                                  }
                                  className="rounded-circle avatar-sm"
                                  alt=""
                                />
                              </div>
                            </div>
                          </td>
                          <td>
                            <p className="font-size-14 m-0">
                              {user.display_name}
                            </p>
                          </td>
                          <td>
                            <div className="text-center">
                              <p>{item.points} points</p>
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const mapStateToProps = state => ({
  leaderboardUsersPoints: state.Leaderboard.leaderboardUsersPoints,
  leaderboardUsersList: state.Leaderboard.leaderboardUsersList,
  selectedEvent: state.experiences.selectedEvent,
})

const mapDispatchToProps = dispatch => ({
  getLeaderboardUsersPoints: values =>
    dispatch(getLeaderboardUsersPoints(values)),
  getLeaderboardUsersList: values => dispatch(getLeaderboardUsersList(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Leaderboard)
